function importAll(r) {   
  let images = {};
 r.keys().map((item) => ( images[item.replace('./', '')] = r(item) ));
  return images;
}

const imagArray = importAll(require.context('../images', true, /\.(png|jpe?g|svg)$/));

export default imagArray;
